import { render, staticRenderFns } from "./ReportActivity.vue?vue&type=template&id=2a707eb8&scoped=true&"
import script from "./ReportActivity.vue?vue&type=script&lang=js&"
export * from "./ReportActivity.vue?vue&type=script&lang=js&"
import style0 from "./ReportActivity.vue?vue&type=style&index=0&id=2a707eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a707eb8",
  null
  
)

export default component.exports